import { useConsole } from "contexts/Console"

export default function Globe({ iframe_url }) {
  const console = useConsole()
  const iframeUrl = new URL(iframe_url)
  iframeUrl.searchParams.set("origin", "dotcom")
  console.verbose("Globe(%o)", { iframeUrl })
  return <iframe src={iframeUrl} width='100%' height='850px' title='description' allow='fullscreen https://www.rolex.org https://spirit.rolex.cn' />
}
